import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_oss_tags_selector_filled = _resolveComponent("oss-tags-selector-filled")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.dialog) = $event)),
    title: "Nouvel état financier",
    minWidth: '40vw',
    onPrevious: _ctx.previous,
    "previous-display": !!(_ctx.step && _ctx.step < 4),
    onClose: _ctx.reset
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          (_ctx.step !== 2)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                class: "pr-2"
              }, {
                default: _withCtx(() => [
                  (_ctx.step < 2)
                    ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                        key: 0,
                        rounded: "",
                        block: "",
                        disabled: _ctx.disableNextWindowItem,
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.step++)),
                        "data-cy": "AccountingBooklet-next",
                        size: "x-large"
                      }, {
                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createTextVNode("Suivant")
                        ])),
                        _: 1
                      }, 8, ["disabled"]))
                    : (_ctx.step === 3)
                      ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                          key: 1,
                          loading: _ctx.loading,
                          rounded: "",
                          block: "",
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.createBooklet(_ctx.exportClass))),
                          "data-cy": "AccountingBooklet-export",
                          size: "x-large"
                        }, {
                          default: _withCtx(() => _cache[44] || (_cache[44] = [
                            _createTextVNode("Exporter")
                          ])),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12",
                class: "pr-2"
              }))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.step) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "d-flex align-center px-8 pb-2",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "d-flex pr-1",
                    cols: "4"
                  }),
                  _createVNode(_component_v_col, {
                    class: "d-flex justify-center pr-1",
                    cols: "4"
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createTextVNode(" Standard ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    class: "d-flex justify-center pr-1",
                    cols: "4"
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode(" Détaillé ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.apolloIsFinished)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportableOperatingAccountJsons, (exportableOA) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (exportableOA.name)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              class: "px-8",
                              "no-gutters": "",
                              key: exportableOA.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  class: "d-flex align-center pr-1",
                                  cols: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(exportableOA.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  class: "d-flex justify-center",
                                  cols: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: exportableOA.standard,
                                      "onUpdate:modelValue": ($event: any) => ((exportableOA.standard) = $event),
                                      class: "my-0",
                                      "hide-details": "",
                                      density: "compact",
                                      "data-cy": 
                                        'AccountingBooklet-exportableOA.standard' + exportableOA.id
                                    
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "data-cy"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  class: "d-flex justify-center",
                                  cols: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: exportableOA.detailed,
                                      "onUpdate:modelValue": ($event: any) => ((exportableOA.detailed) = $event),
                                      class: "my-0",
                                      "hide-details": "",
                                      density: "compact",
                                      "data-cy": 
                                        'AccountingBooklet-exportableOA.detailed' + exportableOA.id
                                    
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "data-cy"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256)),
                    (_ctx.partitionTags && _ctx.partitionTags.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_v_row, {
                            class: "py-4 d-flex justify-center",
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "11" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_divider)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, {
                            class: "px-8",
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                class: "d-flex align-center pr-1",
                                cols: "4"
                              }, {
                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                  _createTextVNode(" Tableau analytique ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                class: "d-flex justify-center",
                                cols: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.operatingAccountFromPartition.standard,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.operatingAccountFromPartition.standard) = $event)),
                                    class: "my-0",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                class: "d-flex justify-center",
                                cols: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.operatingAccountFromPartition.detailed,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.operatingAccountFromPartition.detailed) = $event)),
                                    class: "my-0",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (
                                _ctx.operatingAccountFromPartition.standard ||
                                _ctx.operatingAccountFromPartition.detailed
                            )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_v_row, {
                                  class: "pl-5 pt-4",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.operatingAccountFromPartition.selectedTables,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.operatingAccountFromPartition.selectedTables) = $event)),
                                          items: _ctx.tableTypes,
                                          "item-value": "id",
                                          label: "Table",
                                          "hide-details": "",
                                          multiple: "",
                                          class: "text-caption",
                                          density: "compact",
                                          "item-title": (item) => item.name
                                        }, null, 8, ["modelValue", "items", "item-title"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  class: "pl-5 pt-4",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.operatingAccountFromPartition.selectedPartition,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.operatingAccountFromPartition.selectedPartition) = $event)),
                                          items: _ctx.partitionTags,
                                          "item-value": "id",
                                          label: "Partition",
                                          "hide-details": "",
                                          class: "text-caption",
                                          density: "compact",
                                          "item-title": (item) => item.name
                                        }, null, 8, ["modelValue", "items", "item-title"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  class: "pl-5 pt-4",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.operatingAccountFromPartition.selectedTags,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.operatingAccountFromPartition.selectedTags) = $event)),
                                          items: _ctx.tags,
                                          "item-value": "id",
                                          label: "Etiquette",
                                          "hide-details": "",
                                          multiple: "",
                                          class: "text-caption",
                                          density: "compact",
                                          "item-title": (item) => item.name
                                        }, null, 8, ["modelValue", "items", "item-title"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    class: "d-flex align-center px-8",
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "d-flex align-center justify-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_progress_circular, {
                            size: 70,
                            width: 7,
                            color: "primary",
                            indeterminate: "",
                            style: {"margin":"24px"}
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                      _createElementVNode("span", null, "Nombre de périodes", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio_group, {
                        modelValue: _ctx.periodsNumber,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.periodsNumber) = $event)),
                        inline: "",
                        class: "d-flex justify-center",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            label: "1",
                            class: "pr-2",
                            value: 1
                          }),
                          _createVNode(_component_v_radio, {
                            label: "2",
                            class: "pr-2",
                            disabled: _ctx.previousAccountingPeriodCount < 1,
                            value: 2
                          }, null, 8, ["disabled"]),
                          _createVNode(_component_v_radio, {
                            label: "3",
                            class: "pr-2",
                            disabled: _ctx.previousAccountingPeriodCount < 2,
                            value: 3
                          }, null, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-center pb-2"
                  }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createElementVNode("span", null, "Choisissez la période N", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: _ctx.accountingClosings && _ctx.accountingClosings.length ? '6' : '8',
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.accountingPeriodSelected,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.accountingPeriodSelected) = $event)),
                        items: _ctx.accountingPeriods,
                        "item-title": (item) => _ctx.formatedAccountingPeriod(item),
                        "return-object": "",
                        label: "Exercice comptable",
                        class: "pr-1",
                        density: "compact"
                      }, null, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }, 8, ["cols"]),
                  (_ctx.accountingClosings && _ctx.accountingClosings.length)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "6",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            modelValue: _ctx.accountingClosingSelected,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accountingClosingSelected) = $event)),
                            items: _ctx.accountingClosings,
                            "item-title": (item) => item.name,
                            "return-object": "",
                            label: "Situation comptable",
                            class: "pl-1",
                            density: "compact"
                          }, null, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center pb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "4",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.startDate,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.startDate) = $event)),
                        items: _ctx.startMonthlyDates,
                        label: "Date de début",
                        class: "pr-1",
                        "hide-details": "",
                        disabled: 
                                _ctx.atLeastOneBalanceSheetSelected ||
                                !_ctx.accountingPeriodSelected ||
                                (!!_ctx.accountingClosingSelected && !!_ctx.accountingClosingSelected.id)
                            ,
                        density: "compact"
                      }, null, 8, ["modelValue", "items", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "4",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.endDate,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.endDate) = $event)),
                        items: _ctx.endMonthlyDates,
                        label: "Date de fin",
                        class: "pl-1",
                        "hide-details": "",
                        disabled: 
                                !_ctx.accountingPeriodSelected ||
                                (!!_ctx.accountingClosingSelected && !!_ctx.accountingClosingSelected.id)
                            ,
                        density: "compact"
                      }, null, 8, ["modelValue", "items", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center pb-2"
              }, {
                default: _withCtx(() => [
                  (_ctx.periodsNumber > 1)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "6",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            label: _ctx.periodNMinus(1),
                            disabled: "",
                            class: "pr-1",
                            density: "compact"
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.periodsNumber > 1)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 1,
                        cols: "6",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            modelValue: _ctx.displayNMinusCompletePeriod,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.displayNMinusCompletePeriod) = $event)),
                            items: [
                                { title: 'Période complète', value: true },
                                { title: 'Même période que N', value: false },
                            ],
                            class: "pl-1",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.periodsNumber > 2)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 2,
                        cols: "8",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            label: _ctx.periodNMinus(2),
                            disabled: "",
                            density: "compact"
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.outputs && _ctx.outputs.length)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "8",
                        class: "d-flex justify-center pb-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_divider)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "d-flex justify-center pb-2"
                      }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createElementVNode("span", null, "Intégration d'un budget", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_menu, null, {
                            activator: _withCtx(({ props: menu }) => [
                              _createVNode(_component_v_text_field_filled, _mergeProps({ "hide-details": true }, { ...menu }, {
                                readonly: "",
                                "append-inner-icon": 'arrow_drop_down',
                                "model-value": _ctx.budgets[_ctx.selectedBudget].name,
                                density: "compact"
                              }), null, 16, ["model-value"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.budgets, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: index,
                                      onClick: ($event: any) => {
                                        _ctx.id = item.id;
                                        _ctx.selectedBudget = index;
                                    },
                                      class: "oss-list-item"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: _ctx.exportWithProjectWatermark,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.exportWithProjectWatermark) = $event)),
                    ripple: false,
                    class: "ml-1 mb-2",
                    title: _ctx.$t('shared.exportWithProjectWatermark'),
                    label: _ctx.$t('shared.exportWithProjectWatermark')
                  }, null, 8, ["modelValue", "title", "label"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_list, {
                subheader: "",
                lines: "two"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(
                            !_ctx.$vuetify.display.mobile
                                ? 'mb-2 oss-list-item'
                                : 'mb-2 px-2 oss-list-item'
                        ),
                    disabled: _ctx.exportWithProjectWatermark,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {
                            _ctx.exportClass = 'excel';
                            _ctx.step = 3;
                        })
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { color: "secondary" }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createTextVNode(" $fa-file-excel ")
                        ])),
                        _: 1
                      })
                    ]),
                    append: _withCtx(() => [
                      _createVNode(_component_v_btn_next)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createTextVNode("Export Excel")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item_subtitle, null, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createTextVNode("Exporter au format .xlsx")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"]),
                  (
                            !_ctx.operatingAccountFromPartition.standard &&
                            !_ctx.operatingAccountFromPartition.detailed
                        )
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        class: _normalizeClass(
                            !_ctx.$vuetify.display.mobile
                                ? 'mb-2 oss-list-item rounded-lg'
                                : 'mb-2 px-2 oss-list-item rounded-lg'
                        ),
                        onClick: _cache[13] || (_cache[13] = ($event: any) => {
                            _ctx.exportClass = 'DOCX';
                            _ctx.step = 3;
                        })
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "secondary" }, {
                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                              _createTextVNode(" $fa-file-word ")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                              _createTextVNode("Docx")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => _cache[38] || (_cache[38] = [
                              _createTextVNode("Exporter au format .docx")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (
                            !_ctx.operatingAccountFromPartition.standard &&
                            !_ctx.operatingAccountFromPartition.detailed
                        )
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        class: _normalizeClass(
                            !_ctx.$vuetify.display.mobile
                                ? 'mb-2 oss-list-item rounded-lg'
                                : 'mb-2 px-2 oss-list-item rounded-lg'
                        ),
                        onClick: _cache[14] || (_cache[14] = ($event: any) => {
                            _ctx.exportClass = 'PDF';
                            _ctx.step = 3;
                        })
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "secondary" }, {
                            default: _withCtx(() => _cache[39] || (_cache[39] = [
                              _createTextVNode(" $fa-file-pdf ")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[40] || (_cache[40] = [
                              _createTextVNode("Pdf")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => _cache[41] || (_cache[41] = [
                              _createTextVNode("Exporter au format .pdf")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 3 }, {
            default: _withCtx(() => [
              (_ctx.exportClass !== 'excel')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                            _createElementVNode("h3", null, "Titre personnalisé :", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.title,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.title) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.options,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.options) = $event)),
                      label: "Avec page de garde",
                      value: "firstpage",
                      density: "compact",
                      "hide-details": ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.options,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.options) = $event)),
                      label: "Arrondir les montants",
                      value: "round",
                      density: "compact",
                      "hide-details": ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.options,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.options) = $event)),
                      label: "Ajouter l'attestation de l'expert-comptable",
                      value: "certificate",
                      density: "compact",
                      "hide-details": ""
                    }, null, 8, ["modelValue"]),
                    (_ctx.exportClass === 'DOCX')
                      ? (_openBlock(), _createBlock(_component_v_checkbox, {
                          key: 0,
                          modelValue: _ctx.options,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.options) = $event)),
                          label: "Ajouter le sommaire",
                          value: "summary",
                          density: "compact",
                          "hide-details": ""
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.options,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.options) = $event)),
                      label: "Ajouter un résumé des infos importantes",
                      value: "dashboardInfos",
                      density: "compact",
                      "hide-details": ""
                    }, null, 8, ["modelValue"])
                  ], 64))
                : (!_ctx.onlyBalanceSheetSelected)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.options,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.options) = $event)),
                              label: "Afficher les montants mensuels",
                              value: "monthly",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
              (_ctx.showTagsSelector)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 2,
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_tags_selector_filled, {
                            modelValue: _ctx.selectedTags,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedTags) = $event)),
                            items: _ctx.usedTagsFather,
                            label: 'Filtrer par étiquettes (SIG / CR / Flash)',
                            itemTitle: "text"
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "onPrevious", "previous-display", "onClose"]))
}